import { I18n } from "@devforce/trailhead-client-locale";
import * as locales from "./locales";

const i18n = new I18n({ helpers: locales });

export function label(
  labelKey: string,
  values: (string | number)[] = []
): string {
  if (values.length) {
    return i18n.t("helpers", labelKey, {
      h: values[0].toString(),
      m: (values.length === 2 && values[1].toString()) || values[0].toString(),
      p: values[0].toString(),
    });
  } else return i18n.t("helpers", labelKey);
}
